import Emitter from "es6-event-emitter";
import Swiper from "swiper/dist/js/swiper";
import throttle from "lodash.throttle";

import publicationListSwiper from "./../templates/publicationListSwiper.dust";

/**
 * Contstructs the Kiosque view
 */
export default class PublicationListSwiper extends Emitter {
  constructor(
    appState,
    DOMContent,
    name,
    titleName,
    contentPackages,
    clickedEvent,
    swipedEvent,
    arrowEvent
  ) {
    super();
    this.appState = appState;
    this.DOMContent = DOMContent;
    this.name = name;
    this.titleName = titleName;
    this.contentPackages = contentPackages;
    this.clickedEvent = clickedEvent;
    this.swipedEvent = swipedEvent;
    this.arrowEvent = arrowEvent;
    this._onWidowResize = throttle(this._onWidowResize, 100);
  }

  createContext() {
    const context = {};
    context.slides = this.contentPackages;
    context.name = this.name;
    context.titleName = this.titleName;
    return context;
  }

  render() {
    if (this.DOMContent) {
      if (this.contentPackages.length === 0) {
        return;
      }
      const container = this.DOMContent.querySelector(`#${this.name}`);
      if (container) {
        Dust.render(
          publicationListSwiper,
          this.createContext(),
          (err, result) => {
            container.innerHTML = result;
            this.setSwiperInstance();
          }
        );
      }
    } else {
      setTimeout(() => {
        this.render();
      }, 100);
    }
  }

  attachListeners() {
    const divs = this.DOMContent.querySelectorAll(
      `.swiper-wrapper-${this.name} .swiper-slide`
    );
    const size = divs.length;
    for (let i = 0; i < size; i++) {
      const div = divs[i];
      div.addEventListener("click", (e) => {
        this.trigger("publicationList:onPublicationClicked", e);
        this.appState.triggerEvent(this.clickedEvent);
      });
    }
    this.DOMContent.querySelector(
      `#${this.name} .publicationList-prev`
    ).addEventListener("click", () => {
      this.clickedArrow = true;
      this.appState.triggerEvent(this.arrowEvent);
      this.swiper.slidePrev();
    });
    this.DOMContent.querySelector(
      `#${this.name} .publicationList-next`
    ).addEventListener("click", () => {
      this.clickedArrow = true;
      this.appState.triggerEvent(this.arrowEvent);
      this.swiper.slideNext();
    });
  }

  hideNavigation() {
    this.DOMContent.querySelector(
      `#${this.name} .publicationList-prev`
    ).classList.remove("sliderList");
    this.DOMContent.querySelector(
      `#${this.name} .publicationList-next`
    ).classList.remove("sliderList");
  }

  showNavigation() {
    this.DOMContent.querySelector(
      `#${this.name} .publicationList-prev`
    ).classList.add("sliderList");
    this.DOMContent.querySelector(
      `#${this.name} .publicationList-next`
    ).classList.add("sliderList");
  }

  calculateSpecs() {
    var dimensions = {};
    const totalWidth =
      this.DOMContent.querySelector(`#${this.name}`).getBoundingClientRect()
        .width -
      2 *
        $(
          this.DOMContent.querySelector(`#${this.name} .publicationList-next`)
        ).outerWidth(true);
    const margin = 30;
    const slideWidth =
      $(this.DOMContent.querySelector(".thumb-wrapper")).outerWidth(true) +
      margin;
    const number = Math.floor(totalWidth / slideWidth);
    const width = number * slideWidth - margin;

    const restValue = this.contentPackages.length % number;
    var slidesOffsetAfter = 0;
    if (this.contentPackages.length > number && restValue > 0) {
      slidesOffsetAfter = (number - restValue) * slideWidth;
    }

    if (
      this.contentPackages.length > 1 &&
      this.contentPackages.length > number
    ) {
      this.showNavigation();
    } else {
      this.hideNavigation();
    }

    dimensions.number = number;
    dimensions.width = width;
    dimensions.margin = margin;
    dimensions.slidesOffsetAfter = slidesOffsetAfter;
    return dimensions;
  }

  resize() {
    if (this.swiper) {
      const dimensions = this.calculateSpecs();
      this.swiper.params.slidesPerView = dimensions.number;
      this.swiper.params.slidesPerGroup = dimensions.number;
      this.swiper.params.width = dimensions.width;
      this.swiper.params.slidesOffsetAfter = dimensions.slidesOffsetAfter;
      this.DOMContent.querySelector(
        `.swiper-container-${this.name}`
      ).style.width = dimensions.width + "px";
      this.swiper.update();
      this.checkArrows();
    }
  }

  checkArrows() {
    if (this.swiper) {
      if (this.swiper.activeIndex == 0) {
        this.DOMContent.querySelector(
          `#${this.name} .publicationList-prev`
        ).classList.add("inactive");
      } else {
        this.DOMContent.querySelector(
          `#${this.name} .publicationList-prev`
        ).classList.remove("inactive");
      }
      if (
        this.swiper.activeIndex + this.swiper.params.slidesPerView >=
        this.contentPackages.length
      ) {
        this.DOMContent.querySelector(
          `#${this.name} .publicationList-next`
        ).classList.add("inactive");
      } else {
        this.DOMContent.querySelector(
          `#${this.name} .publicationList-next`
        ).classList.remove("inactive");
      }
    }
  }

  setThumbHeight(container) {
    const sliderThumbs = document.querySelectorAll(
      `${container} .thumb-wrapper`
    );
    let biggestHeight = 0;
    [].forEach.call(sliderThumbs, (sliderThumb) => {
      if (sliderThumb.clientHeight > biggestHeight) {
        biggestHeight = sliderThumb.clientHeight;
      }
    });
    [].forEach.call(sliderThumbs, (sliderThumb) => {
      sliderThumb.style.minHeight = biggestHeight + "px";
    });
  }

  setSwiperInstance() {
    const dimensions = this.calculateSpecs();
    this.DOMContent.querySelector(
      `.swiper-container-${this.name}`
    ).style.width = dimensions.width + "px";
    this.swiper = new Swiper(`.swiper-container-${this.name}`, {
      slidesPerView: dimensions.number,
      slidesPerGroup: dimensions.number,
      spaceBetween: dimensions.margin,
      slidesOffsetAfter: dimensions.slidesOffsetAfter,
      updateOnImagesReady: true,
      width: dimensions.width,
      onTransitionEnd: () => {
        this.checkArrows();
        if (this.clickedArrow) {
          this.clickedArrow = false;
        } else {
          this.appState.triggerEvent(this.swipedEvent);
        }
      },
      onImagesReady: () => {
        this.setThumbHeight(`.swiper-container-${this.name}`);
      },
    });
    window.addEventListener("resize", this._onWidowResize);
    this.checkArrows();
    this.attachListeners();
  }

  _onWidowResize = () => {
    this.resize();
  };
}



// WEBPACK FOOTER //
// ./src/web/home/components/publicationListSwiper.js